import {Component, AfterViewInit, ViewChild} from '@angular/core';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {IdexService} from 'app/idex.service';
import {SelectionModel} from '@angular/cdk/collections';
import {Toast} from 'app/shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {merge, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {MatSort} from '@angular/material/sort';
import {PaginatorComponent} from '../../shared/paginator/paginator.component';
import {ShareComponent} from '../share/share.component';
import {MatLegacyTabGroup as MatTabGroup} from '@angular/material/legacy-tabs';

@Component({
   selector: 'app-templates',
   templateUrl: './templates.component.html',
   styleUrls: ['./templates.component.css']
})
export class TemplatesComponent implements AfterViewInit {
   isLoadingResults = false;
   isLoadingResultsShare = false;
   isRateLimitReached = false;
   isRateLimitReachedShare = false;
   showTabShare = false;
   resultsLength = 0;
   resultsLengthShare = 0;
   tabType: any;
   errorMessage: any;
   public filterValue: any;
   public filterValueShare: any;
   public indexSelected = 0;

   clickActive: boolean;
   selectedRowIndex: number;
   displayedColumns = ['select', 'no', 'template_name', 'last_update_date', 'active', 'menu'];
   displayedColumnsShare = ['no', 'template_name', 'create_by', 'last_update_date'];
   tpDataSource: MatTableDataSource<TemplateList>;
   private share: MatDialogRef<ShareComponent>;
   tpDataSourceShare: MatTableDataSource<TemplateList>;
   selection = new SelectionModel<TemplateList>(true, []);
   templateData: TemplateList[] = [];
   templateDataShare: TemplateList[] = [];
   filterTpValue: any;
   filterTpValueShare: any;
   pageSize = 50;
   pageSizeShare = 50;
   searching: any;
   searchingShare: any;
   searchFocused: boolean;
   searchFocusedShare: boolean;
   preventBlur: boolean;
   preventBlurShare: boolean;
   searchResult: any[];
   searchResultShare: any[];
   searchvalue: any;
   searchvalueShare: any;
   private timer: any;
   sortOrder = 'template_name';
   sortOrderShare = 'template_name';
   sortDirect = 'asc';
   sortDirectShare = 'asc';
   sortOrderTmp: string;
   sortOrderTmpShare: string;
   sortDirectTmp: string;
   sortDirectTmpShare: string;
   private page = 0;
   private pageShare = 0;
   tab: any;
   clearSearch: any;
   @ViewChild('btnDel', {static: true}) public buttonDel: MatButton;
   @ViewChild('sortMe') sort: MatSort;
   @ViewChild('sortShare') sortShare: MatSort;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;
   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild(PaginatorComponent, {static: true}) paginatorShare: PaginatorComponent;

   constructor(protected service: IdexService,
               private dialog: MatDialog,
               public toast: Toast,
               public translate: TranslateService,
               private router: Router) {
      const tpSort = localStorage.getItem('tpSort');
      const tpSortShare = localStorage.getItem('tpSortShare');
      const tpSortDirect = localStorage.getItem('tpSortDirect');
      const tpSortDirectShare = localStorage.getItem('tpSortDirectShare');
      const tpPageIndex = localStorage.getItem('tpPageIndex');
      const tpPageIndexShare = localStorage.getItem('tpPageIndexShare');
      const tpPageSize = localStorage.getItem('tpPageSize');
      const tpPageSizeShare = localStorage.getItem('tpPageSizeShare');

      if (tpSort) {
         this.sortOrderTmp = tpSort;
         this.sortOrder = this.sortOrderTmp;
         localStorage.removeItem('tpSort');
      }

      if (tpSortShare) {
         this.sortOrderTmpShare = tpSortShare;
         this.sortOrderShare = this.sortOrderTmpShare;
         localStorage.removeItem('tpSortShare');
      }

      if (tpSortDirect) {
         this.sortDirectTmp = tpSortDirect;
         this.sortDirect = this.sortDirectTmp;
         localStorage.removeItem('tpSortDirect');
      }

      if (tpSortDirectShare) {
         this.sortDirectTmpShare = tpSortDirectShare;
         this.sortDirectShare = this.sortDirectTmpShare;
         localStorage.removeItem('tpSortDirectShare');
      }

      if (tpPageIndex) {
         this.page = parseInt(tpPageIndex, 10);
         localStorage.removeItem('tpPageIndex');
      } else {
         this.page = -1;
      }

      if (tpPageIndexShare) {
         this.pageShare = parseInt(tpPageIndexShare, 10);
         localStorage.removeItem('tpPageIndexShare');
      } else {
         this.pageShare = -1;
      }

      if (tpPageSize) {
         this.pageSize = parseInt(tpPageSize, 10);
         localStorage.removeItem('tpPageSize');
      } else {
         this.pageSize = 50;
      }

      if (tpPageSizeShare) {
         this.pageSizeShare = parseInt(tpPageSizeShare, 10);
         localStorage.removeItem('tpPageSizeShare');
      } else {
         this.pageSizeShare = 50;
      }
   }

   ngAfterViewInit() {
      sessionStorage.removeItem('tpSearchShare');
      if (this.tab === '1') {
         this.indexSelected = 1;
         localStorage.removeItem('selectTabIndex');
      }
      setTimeout(() => {
         this.clickActive = false;
         this.buttonDel.disabled = true;

         if (this.page !== -1) {
            this.paginator.page = this.page;
         } else {
            this.paginator.page = 0;
         }
         if (this.pageShare !== -1) {
            this.paginatorShare.page = this.pageShare;
         } else {
            this.paginatorShare.page = 0;
         }
         this.getTemplateList('load');
         this.getTemplateListShare('load');
         this.tab = localStorage.getItem('selectTabIndex');
         setTimeout(() => {
            if (this.tab === '0') {
               this.indexSelected = 0;
               localStorage.removeItem('selectTabIndex');
            }
            if (this.tab === '1') {
               this.indexSelected = 1;
               localStorage.removeItem('selectTabIndex');
            }
         }, 100);
      }, 0);
   }


   LoadGroupTabs(event) {
      const indexSelected = event.index;
      if (indexSelected === 0) {
         this.tabType = 'M';
      } else if (indexSelected === 1) {
         this.tabType = 'S';
      }
      setTimeout(() => {
         this.clearSearch = localStorage.getItem('clearSearch');
         if (this.clearSearch !== 'false') {
            this.searching = '';
            this.searchingShare = '';
            sessionStorage.removeItem('tpSearch');
            sessionStorage.removeItem('tpSearchShare');
         } else {
            localStorage.removeItem('clearSearch');
         }
         if (this.indexSelected === 0) {
            this.getTemplateList('load');
         }
         if (this.indexSelected === 1) {
            this.getTemplateListShare('load');
         }
      }, 100);
      this.selection.clear();
      this.buttonDel.disabled = true;
   }

   getTemplateList(type) {
      this.loader.show();
      merge(this.paginator.page)
         .pipe(
            startWith({}),
            switchMap(() => {
               this.isLoadingResults = true;
               if (this.paginator.size !== undefined) {
                  this.pageSize = this.paginator.size;
               }

               const itemSearch = sessionStorage.getItem('tpSearch') || '';
               this.filterTpValue = itemSearch;
               this.searching = itemSearch;
               if (this.filterTpValue === undefined) {
                  this.filterTpValue = '';
               }

               let sort = 'template_name';
               let order = 'asc';
               if (this.sortOrderTmp) {
                  sort = this.sortOrderTmp;
                  this.sortOrderTmp = undefined;

                  if (this.sortDirectTmp) {
                     order = this.sortDirectTmp;
                     this.sortDirectTmp = undefined;
                  }
               } else if (this.sort) {
                  sort = this.sort.active;
                  order = this.sort.direction;
               }

               if (type === 'sort') {
                  this.paginator.page = 0;
               } else if (this.page !== -1) {
                  this.paginator.page = this.page;
                  this.page = -1;
               }

               return this.service.getTemplateAll(
                  this.pageSize, this.paginator.page, sort, order, encodeURIComponent(this.filterTpValue), 'f');
            }),
            map(data => {
               // Flip flag to show that loading has finished.
               this.isLoadingResults = false;
               this.isRateLimitReached = false;
               this.selectedRowIndex = -1;
               this.selection.clear();
               this.buttonDel.disabled = true;
               this.resultsLength = data.totalCount;
               this.templateData = data.items;
               this.tpDataSource = new MatTableDataSource(this.templateData);
               if (this.paginator.page !== data.pageIndex) {
                  this.paginator.page = data.pageIndex;
               }
               this.loader.hide();
               return data.items;
            }),
            catchError(() => {
               this.isLoadingResults = false;
               // Catch if the GitHub API has reached its rate limit. Return empty data.
               this.isRateLimitReached = true;
               this.loader.hide();
               return observableOf([]);
            })
         ).subscribe(data => this.tpDataSource.data = data);
   }

   getTemplateListShare(type) {
      this.loader.show();
      merge(this.paginatorShare.page)
         .pipe(
            startWith({}),
            switchMap(() => {
               this.isLoadingResultsShare = true;
               if (this.paginatorShare.size !== undefined) {
                  this.pageSizeShare = this.paginatorShare.size;
               }
               const itemSearch = sessionStorage.getItem('tpSearchShare') || '';
               this.filterTpValueShare = itemSearch;
               this.searchingShare = itemSearch;
               if (this.filterTpValueShare === undefined) {
                  this.filterTpValueShare = '';
               }
               let sortShare = 'template_name';
               let orderShare = 'asc';
               if (this.sortOrderTmpShare) {
                  sortShare = this.sortOrderTmpShare;
                  this.sortOrderTmpShare = undefined;
                  if (this.sortDirectTmpShare) {
                     orderShare = this.sortDirectTmpShare;
                     this.sortDirectTmpShare = undefined;
                  }
               } else if (this.sortShare) {
                  sortShare = this.sortShare.active;
                  orderShare = this.sortShare.direction;
               }

               if (type === 'sort') {
                  this.paginatorShare.page = 0;
               } else if (this.pageShare !== -1) {
                  this.paginatorShare.page = this.pageShare;
                  this.pageShare = -1;
               }
               return this.service.getTemplateShare(
                  this.pageSizeShare, this.paginatorShare.page, sortShare, orderShare, encodeURIComponent(this.filterTpValueShare), 'f' , 'f');
            }),
            map(data => {
               // Flip flag to show that loading has finished.
               this.isLoadingResultsShare = false;
               this.isRateLimitReachedShare = false;
               this.selectedRowIndex = -1;
               this.selection.clear();
               this.buttonDel.disabled = true;
               this.resultsLengthShare = data.totalCount;
               this.templateDataShare = data.items;
               if (this.templateDataShare.length !== 0) {
                  this.showTabShare = true;
               }
               this.tpDataSourceShare = new MatTableDataSource(this.templateDataShare);
               if (this.paginatorShare.page !== data.pageIndex) {
                  this.paginatorShare.page = data.pageIndex;
               }
               this.loader.hide();
               return data.items;
            }),
            catchError(() => {
               this.isLoadingResultsShare = false;
               // Catch if the GitHub API has reached its rate limit. Return empty data.
               this.isRateLimitReachedShare = true;
               this.loader.hide();
               return observableOf([]);
            })
         ).subscribe(data => this.tpDataSourceShare.data = data);
   }

   activeTemplate(id: any, name: any, active: any, row: any) {
      this.clickActive = true;
      const templateId = id.innerHTML;
      const templateName = name.innerHTML;
      const activeFlg = active.checked;
      if (activeFlg === false) {
         this.service.activeTemplate(templateId, templateName)
            .subscribe((response) => {
               this.toast.success(response);
               this.getTemplateList('load');
            });
      } else {
         this.service.inactiveTemplate(templateId, templateName)
            .subscribe((response) => {
               this.toast.warn(response);
               if (row.shareId !== 0) {
                  this.service.unshare(row.templateId, 'TP')
                     .subscribe(
                        () => {
                           this.getTemplateList('load');
                        },
                        error => {
                           this.errorMessage = error;
                        });
               } else {
                  this.getTemplateList('load');
               }
            });
      }
   }

   highlight(row) {
      if (!this.clickActive) {
         this.selectedRowIndex = row.no;

         this.setSortPaging();
         this.openEditTemplate(row);
      }
      this.clickActive = false;
   }

   highlightShare(row) {
      if (!this.clickActive) {
         this.selectedRowIndex = row.no;

         this.setSortPagingShare();
         this.openEditTemplateShare(row);
      }
      this.clickActive = false;
   }

   onSearch(input: any, filterValue: string) {
      this.searchFocused = false;
      this.searchvalue = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         this.filterValue = filterValue.trim(); // Remove whitespace
         this.filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches

         this.filterTpValue = filterValue;

         sessionStorage.setItem('tpSearch', this.filterTpValue);
         this.setSortPaging();
         this.getTemplateList('search');
         input.blur();
      }
   }

   onSearchShare(input: any, filterValue: string) {
      this.searchFocusedShare = false;
      this.searchvalueShare = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         this.filterValueShare = filterValue.trim(); // Remove whitespace
         this.filterValueShare = filterValue.toLowerCase(); // Datasource defaults to lowercase matches

         this.filterTpValueShare = filterValue;

         sessionStorage.setItem('tpSearchShare', this.filterTpValueShare);
         this.setSortPagingShare();
         this.getTemplateListShare('search');
         input.blur();
      }
   }

   setSortPaging() {
      if (this.sort) {
         localStorage.setItem('tpSort', this.sort.active);
         localStorage.setItem('tpSortDirect', this.sort.direction);
      }
      if (this.paginator) {
         localStorage.setItem('tpPageIndex', this.paginator.page.toString());
         localStorage.setItem('tpPageSize', this.paginator.size.toString());
      }
   }

   setSortPagingShare() {
      if (this.sortShare) {
         localStorage.setItem('tpSortShare', this.sortShare.active);
         localStorage.setItem('tpSortDirectShare', this.sortShare.direction);
      }
      if (this.paginatorShare) {
         localStorage.setItem('tpPageIndexShare', this.paginatorShare.page.toString());
         localStorage.setItem('tpPageSizeShare', this.paginatorShare.size.toString());
      }
   }

   onSearchChange(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchChangeShare(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocusedShare = true;
      }

      this.searchResultShare = null;
      this.searchChangeShare(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   onSearchBlurShare() {
      setTimeout(() => {
         if (!this.preventBlurShare) {
            this.searchFocusedShare = false;
         }
      }, 300);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   onSearchFocusShare(input: any) {
      this.searchFocusedShare = true;
      this.searchChangeShare(input);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.service.getTemplateAll(0, 0, '',
            '', kw, 't')
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResult = data;
                  }
               });
      }, 300);
   }

   searchChangeShare(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.service.getTemplateShare(0, 0, '',
            '', kw, 't', 'f')
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResultShare = data;
                  }
               });
      }, 300);
   }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.tpDataSource.data.length;

      if (numSelected > 0) {
         this.buttonDel.disabled = false;
      } else {
         this.buttonDel.disabled = true;
      }
      return numSelected === numRows;
   }

   /** Selects all rows if they are not all selected; otherwise clear selection. */
   masterToggle() {
      if (this.isAllSelected()) {
         this.selection.clear();
         this.buttonDel.disabled = true;
      } else {
         this.tpDataSource.data.forEach(row => this.selection.select(row));
         this.buttonDel.disabled = false;
      }
   }

   disableButton(row: any) {
      const numSelected = this.selection.selected.length;
      if (numSelected > 0) {
         this.buttonDel.disabled = false;
      } else {
         this.buttonDel.disabled = true;
      }
      return this.selection.isSelected(row);

   }

   deleteTemplate() {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('main.templates').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const IdList: number[] = [];
            for (let i = 0; i < this.selection.selected.length; i++) {
               IdList.push(this.selection.selected[i].templateId);
            }
            this.service.deleteTemplate(IdList)
               .subscribe((response) => {
                  this.toast.success(response);
                  this.selection.clear();
                  this.getTemplateList('load');
                  this.getTemplateListShare('load');
               });
         }
      });
   }

   openNewTemplate() {
      this.router.navigate(['/create-template']);
   }

   openEditTemplate(row) {
      localStorage.setItem('clearSearch', 'false');
      localStorage.setItem('selectTabIndex', '0');
      this.router.navigate(['/create-template'],
         {
            queryParams: {
               p: JSON.stringify({
                  id: row.templateId,
                  mode: 'edit'
               })
            }
         });
   }

   openEditTemplateShare(row) {
      localStorage.setItem('clearSearch', 'false');
      localStorage.setItem('selectTabIndex', '1');
      this.router.navigate(['/create-template'],
         {
            queryParams: {
               p: JSON.stringify({
                  id: row.templateId,
                  mode: 'edit',
                  auto: 't',
                  share: 't',
                  pagecheck: 'TP',
                  viewMode: true
               })
            }
         });
   }

   tabShare(row) {
      if (row.shareId !== 0) {
         this.service.getAllShare(row.shareId)
            .subscribe((data: any) => {
               this.share.componentInstance.shareGroup = data.group;
               this.share.componentInstance.shareUser = data.contact;
               this.share.componentInstance.shareSites = data.sites;
               this.share.componentInstance.membersShare = data.UserShares;
               this.share.componentInstance.groupShare = data.GroupShare;
               this.share.componentInstance.siteShare = data.SiteShares;
            }, error => {
               this.errorMessage = error;
            });
      }
      if (!this.clickActive) {
         this.share = this.dialog.open(ShareComponent, {
            disableClose: true,
            data: this,
            width: '600px'
         });
         this.share.componentInstance.objectId = row.templateId;
         this.share.componentInstance.shareId = row.shareId;
         this.share.componentInstance.objectType = 'TP';
         this.share.afterClosed().subscribe(result => {
            this.getTemplateList('load');
            this.getTemplateListShare('load');
         });
      }
      this.clickActive = false;
   }
}

export interface TPInfo {
   items: TemplateList[];
   totalCount: number;
   pageIndex: number;
}

export interface TemplateList {
   no: number;
   templateId: number;
   templateName: string;
   active: boolean;
   createDate: string;
   createBy: string;
   lastUpdateDate: string;
   lastUpdateBy: string;
   shareId: any;
}


